exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".consigna-detail-icon {\n  margin: 6px 18px 10px 10px;\n  color: #565656; }\n\n.message-profile-image {\n  width: 30px;\n  height: 30px; }\n\np {\n  font-size: 15px;\n  color: #565656; }\n\n.message-header span {\n  font-weight: bold;\n  font-size: 15px; }\n\n.message-header p {\n  font-size: 13px; }\n\n.message {\n  border-bottom: 2px solid #f4f4f4; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/consigna-detail/consigna-detail.component.scss
// module id = ../../../../../src/app/components/agenda/consigna-detail/consigna-detail.component.scss
// module chunks = 0